/**
 * Работа с адресами: убираем дубль города.
 *
 * Геокодер и исторические данные отдают адрес вместе с городом
 * («г Пермь, ул Ленина, д 100»), а город в заявке хранится отдельным полем.
 * Без нормализации в интерфейсе получается «Пермь, г Пермь, ул Ленина».
 *
 * Зеркало серверного bitrix_app/address_utils.py — логика должна совпадать,
 * иначе на сервере и на клиенте адрес будет выглядеть по-разному.
 */

const PLACE_PREFIXES = [
    'г', 'гор', 'город', 'п', 'пос', 'посёлок', 'поселок',
    'пгт', 'рп', 'с', 'село', 'ст', 'станица', 'д', 'деревня',
    'мкр', 'микрорайон',
];

/** Кусок адреса → сравнимый вид: без префикса, регистра, «ё» и лишних знаков */
const normToken = (value = '') => {
    let text = String(value || '').trim().toLowerCase().replace(/ё/g, 'е');
    text = text.replace(/[«»"'()]/g, '').replace(/\s+/g, ' ').replace(/^[.,\s]+|[.,\s]+$/g, '');
    if (!text) return '';
    const parts = text.split(' ');
    if (parts.length > 1 && PLACE_PREFIXES.includes(parts[0].replace(/\./g, ''))) {
        text = parts.slice(1).join(' ').trim();
    }
    return text;
};

/** Есть ли город в первых двух сегментах адреса */
export const addressContainsCity = (address = '', city = '') => {
    const cityNorm = normToken(city);
    if (!cityNorm || !address) return false;
    const segments = String(address).split(',').map(normToken).filter(Boolean);
    return segments.slice(0, 2).includes(cityNorm);
};

/**
 * Убирает город из НАЧАЛА адреса. Внутри строки («ул Московская») не трогает.
 *   «г Пермь, ул Ленина, д 100» + «Пермь» → «ул Ленина, д 100»
 *   «Пермь, г Пермь, ул Ленина» + «Пермь» → «ул Ленина»
 *   «ул Московская, д 5»        + «Москва» → без изменений
 */
export const stripCityPrefix = (address = '', city = '') => {
    const raw = String(address || '').trim();
    const cityNorm = normToken(city);
    if (!raw || !cityNorm) return raw;

    const segments = raw.split(',').map(s => s.trim()).filter(Boolean);
    while (segments.length && normToken(segments[0]) === cityNorm) segments.shift();
    return segments.join(', ');
};

/** «Город, адрес» одной строкой без дубля */
export const composeAddress = (city, address) => {
    const cityClean = String(city || '').trim();
    const addrClean = String(address || '').trim();
    if (!addrClean) return cityClean;
    if (!cityClean) return addrClean;
    if (addressContainsCity(addrClean, cityClean)) return addrClean;
    return `${cityClean}, ${addrClean}`;
};